<v-card rounded density="compact"><v-data-table></v-data-table></v-card>